<script>
import { Pie } from "vue-chartjs";

export default {
  extends: Pie,
  props: ['data'],
  methods: {
    generateRandomColor() {
      const letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    generateColors(count) {
      const staticColors = ['#f47068', '#ffb3ae', '#06d6a0', '#1697a6', '#ef476f', '#ffc24b'];
      const colors = [...staticColors];
      for (let i = staticColors.length; i < count; i++) {
        colors.push(this.generateRandomColor());
      }

      return colors;
    }
  },
  mounted() {
    this.renderChart(
      {
        labels: this.data['labels'],
        datasets: [
          {
            data: this.data['counts'],
            backgroundColor: this.generateColors(this.data['labels'].length)
          }
        ]
      },
      {
        responsive: true,
        maintainAspectRatio: false,
      }
    );
  }
};
</script>
